export const VISIT_FILTER_KEY = 'visitFilterCriteria';
export const AUTHORIZE_FILTER_KEY = 'authorizeFilterCriteria';

export const DEFAULT_FILTERS = {
  SAID: '',
  memberNo: '',
  patientName: '',
  monthYear: '',
  recentDays: '60',
};

const getStoredFiltersForKey = (storageKey) => {
  try {
    const raw = localStorage.getItem(storageKey);
    return raw ? { ...DEFAULT_FILTERS, ...JSON.parse(raw) } : DEFAULT_FILTERS;
  } catch {
    return DEFAULT_FILTERS;
  }
};

export const getStoredVisitFilters = () => {
  return getStoredFiltersForKey(VISIT_FILTER_KEY);
};

export const getStoredAuthorizeFilters = () => {
  return getStoredFiltersForKey(AUTHORIZE_FILTER_KEY);
};

export const clearVisitFilters = () => {
  localStorage.removeItem(VISIT_FILTER_KEY);
};

export const applyVisitFilters = (visits, filters) => {
  if (!filters || !visits) return visits;

  return visits.filter((visit) => {
    const { SAID, patientName, monthYear } = filters;

    // Check SAID (exact match)
    if (SAID && visit.SAID?.toString() !== SAID) {
      return false;
    }

    // Check patientName (exact match)
    if (patientName && visit.patientName?.toString() !== patientName) {
      return false;
    }

    // Check monthYear (prefix match on YYYY-MM)
    if (monthYear && !visit.date.startsWith(monthYear)) {
      return false;
    }

    return true;
  });
};
